/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import PhoneNumber from "awesome-phonenumber";

/**
 * This will check the string contains only numbers
 * @param {*} number This contain extension number
 * @returns A boolean value true or false
 */
export function isValidExtension(number) {
	return number && number.match(/^[0-9]+$/);
}

/**
 * Uses awesome-phonenumber to check if a phone number is valid.
 * @param {String} number The number to verify
 * @returns true if number is valid.
 */
export function isValidPhoneNumber(number) {
	if (number) {
		const phone = new PhoneNumber(number);
		return phone.isValid();
	}
	return false;
}
